import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var LayoutWindowSvg = function LayoutWindowSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 2h20v20H2zm1.481 6.111v12.407H8.02V8.111zm0-1.481h17.037V3.48H3.482zM20.518 8.11H9.5v12.407h11.019z",
    clipRule: "evenodd"
  }));
};
export var LayoutWindow = function LayoutWindow(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: LayoutWindowSvg
  }));
};